import React, { useContext } from 'react'
import { AuthContext } from '../../auth/AuthContexts'
import { types } from '../../types/types'


import imageCover from '../../assets/heroes/marvel-what-if.webp'
import gradient from "../../assets/heroes/gradient.svg"


export const LoginScreen = ({ history }) => {

    const { dispatch } = useContext(AuthContext)

    const handleLogin = () => {
        // history.push('/') redirige  pero guarda el history anterior

        const lastPath = localStorage.getItem('lastPath') || '/'

        dispatch({
            type: types.login,
            payload: {
                name: 'eury'
            }
        })
        history.replace(lastPath)//remplaza la direcion y el historial no se guarda
    }

    return (
        <div className='login__container'>
            <div className='img__login'>
                <img src={imageCover} alt='what-if-marvel' />
            </div>
            <div className='form__container'>
                <img src={gradient} alt='what-if-marvel' />
                <form>
                    <h1>Login</h1>
                    <hr />
                    <button
                        className='btn btn-primary'
                        onClick={handleLogin}
                    >
                        Ingresar
                    </button>

                </form>
            </div>
        </div >
    )
}

// el history es una prop que puedo aser que me llegue por parametro !!hay mas
//el history => tine como un istorial y puedes navegar entre rutas con el;